module.exports = __webpack_public_path__ + "static/media/google_04.676f2e5d.svg";